// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'project';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.938 17.438a1.125 1.125 0 0 0 1.124-1.125v-4.5a1.125 1.125 0 0 0-1.124-1.126h-6.75V9.563a1.125 1.125 0 0 0-1.125-1.126H1.688A1.125 1.125 0 0 0 .563 9.563v6.75a1.125 1.125 0 0 0 1.125 1.125z' />
    <path d='M5.063 8.438v-6.75A1.125 1.125 0 0 1 6.188.563h7.971c.298 0 .584.118.795.329l2.154 2.154c.211.21.33.497.33.795v10.221a1.125 1.125 0 0 1-1.125 1.126h-2.25M8.438 3.938h5.624M8.438 7.313h5.624' />
  </g>
);

export const viewBox = '0 0 18 18';
